import BulkEditButton from 'components/BulkEditButton/BulkEditButton';
import ConceptSearchBar from 'components/Searchbar/ConstrainedForecastSearchBar';
import CircularProgress from 'components/circularProgress';
import Navbar from 'components/navbar';
import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Outlet } from 'react-router-dom';
import BulkUpdate from 'screens/FDPScreen/components/ConstraintForecastScreen/components/BulkUpdate';
import { useEffect } from 'react';

const ConstraintForecastHoc = () => {
  const {
    ConstrainedForecastViewStore: {
      percentProgress,
      isUnconstrainedForecastProgressLoading,
      toggleBulkUpdateModal,
      resetStore: resetViewStore,
    },
    ConstrainedForecastEditStore: { resetStore: resetEditStore },
  } = useStore();

  useEffect(() => {
    // Cleanup function will be called when component unmounts
    return () => {
      resetViewStore();
      resetEditStore();
    };
  }, [resetViewStore, resetEditStore]);

  return (
    <div>
      <Navbar
        heading="FDP - Constrained Forecast"
        searchComponent={<ConceptSearchBar />}
        progressComponent={
          <CircularProgress
            value={percentProgress.percentage}
            toggleFunction={toggleBulkUpdateModal}
            loading={isUnconstrainedForecastProgressLoading}
          />
        }
        bulkEditComponent={<BulkEditButton path="/fdp/constrained_forecast/bulk_edit" />}
      />
      <Outlet />
      <BulkUpdate />
    </div>
  );
};

export default observer(ConstraintForecastHoc);
